module.exports = __webpack_public_path__ + "static/media/tokopedia.f7321349.svg";